<div fxLayout="column" fxLayoutAlign="start center">
  <div app-search-panel class="content-block dx-card responsive-paddings search-container" style="width: 95vw"
       (formSubmitted)="setFilters($event)"></div>
  <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw !important;">
    <dx-drawer
      [openedStateMode]="'overlap'"
      [revealMode]="'slide'"
      class='drawer'
      [position]='"after"'
      [template]='"template"'
      [(opened)]='drawerOpened'
      [closeOnOutsideClick]='true'>
      <div *dxTemplate="let data of 'template'"
           style='width: 800px; height: -webkit-fill-available; height: fill-available;'>
        <div class='drawer-card'>
          <div class='container'>
            <app-drawer-order [orderId]='orderId' [abnormalLabel]='abnormalLabel'
                              [closeEvent]='closeDrawer'></app-drawer-order>
          </div>
        </div>
      </div>
      <app-orders-grid [clean]="saved" [filters]="filters" (previewClicked)="openPreviewDrawer($event)" (selectionChanged)="ordersSelectionChanged($event)"></app-orders-grid>
      <app-result-manager [orders]="selectedOrders" (resultsSaved)="onSaved()"></app-result-manager>
    </dx-drawer>
  </div>
</div>
